import Enum from './enum'

class AccreditationType extends Enum
{
  constructor(value) {
    super(value);
  }
}

AccreditationType.init({
  NONE: 'None',
  DIGITAL_SIGNATURE: 'EP',
  ACCREDITATION: 'Accreditation'
}, {
  NONE: 'accreditation-type.none',
  DIGITAL_SIGNATURE: 'accreditation-type.digital-signature',
  ACCREDITATION: 'accreditation-type.accreditation'
});

export default AccreditationType;
